function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("circle", {
  cx: 24,
  cy: 24,
  r: 13.25,
  stroke: "#333",
  strokeWidth: 1.5
});

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M30.547 23.582l-4.42-4.339a.854.854 0 00-1.195.003.826.826 0 00.003 1.18l2.966 2.913H17.846a.84.84 0 00-.846.834c0 .46.379.834.846.834H27.9l-2.966 2.913a.827.827 0 00-.003 1.18.854.854 0 001.196.003l4.418-4.339a.828.828 0 000-1.182z",
  fill: "#333"
});

function SvgIconRightArrow(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    viewBox: "0 0 48 48",
    fill: "none"
  }, props), _ref, _ref2);
}

export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDgiIGhlaWdodD0iNDgiIHZpZXdCb3g9IjAgMCA0OCA0OCIgZmlsbD0ibm9uZSIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZSBjeD0iMjQiIGN5PSIyNCIgcj0iMTMuMjUiIHN0cm9rZT0iIzMzMzMzMyIgc3Ryb2tlLXdpZHRoPSIxLjUiLz4KPHBhdGggZD0iTTMwLjU0NjYgMjMuNTgyM0wyNi4xMjc1IDE5LjI0M0MyNS43OTY1IDE4LjkxNzkgMjUuMjYxMSAxOC45MTkyIDI0LjkzMTcgMTkuMjQ1OEMyNC42MDIyIDE5LjU3MjQgMjQuNjAzNSAyMC4xMDA2IDI0LjkzNDUgMjAuNDI1N0wyNy45MDEgMjMuMzM4NUgxNy44NDU2QzE3LjM3ODYgMjMuMzM4NSAxNyAyMy43MTIxIDE3IDI0LjE3MjlDMTcgMjQuNjMzNyAxNy4zNzg2IDI1LjAwNzIgMTcuODQ1NiAyNS4wMDcySDI3LjkwMDlMMjQuOTM0NSAyNy45MkMyNC42MDM1IDI4LjI0NTEgMjQuNjAyMyAyOC43NzMzIDI0LjkzMTcgMjkuMDk5OUMyNS4yNjEyIDI5LjQyNjYgMjUuNzk2NiAyOS40Mjc3IDI2LjEyNzYgMjkuMTAyN0wzMC41NDU5IDI0Ljc2NDJDMzAuODc3MSAyNC40MzgxIDMwLjg3NjggMjMuOTA3MyAzMC41NDY2IDIzLjU4MjNaIiBmaWxsPSIjMzMzMzMzIi8+Cjwvc3ZnPgo=";
export { SvgIconRightArrow as ReactComponent };